import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export const VaultNextStep = ({ from }) => (
  <Link to="/speech-vault" data-testid="vault-next-step"
    onClick={() => trackEvent("select_promotion", { promotion_id: "speech_vault_next_step", creative_slot: from })}
    className="mt-8 flex items-center gap-4 border-2 border-[#1E1E1E] bg-white p-4 text-left hover:bg-[#F5F0EA] transition-colors">
    <img src="/products/speech-vault-cover.png" alt="Coach's Speech Vault" className="w-16 h-20 object-cover border border-[#D3CFC0]" />
    <span className="flex-1">
      <span className="block text-xs uppercase tracking-wide font-bold" style={{ color: "#DB9130" }}>Your next step · $19</span>
      <span className="block font-head uppercase text-lg text-[#1E1E1E]">Coach&apos;s Speech Vault</span>
      <span className="block text-sm text-[#3A3A3A]">Six ready-to-deliver speeches for the nights a season turns on.</span>
    </span>
    <ArrowRight size={18} className="text-[#1E1E1E] shrink-0" />
  </Link>
);
